<template>
	<div class="wrap">
		<div class="head">
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/12228@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>98</div>
					<div>当前待办</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/20@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>48,566</div>
					<div>本周申请</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10784@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>8,309</div>
					<div>本周受理</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10785@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>46,560</div>
					<div>本周不予受理</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10786@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>98</div>
					<div>延续申请</div>
				</div>
			</div>
			<div class="head_item">
				<div class="item_img">
					<img src="@/assets/images/10787@3x.png" alt="">
				</div>
				<div class="item_text">
					<div>9,198,176</div>
					<div>新办申请</div>
				</div>
			</div>
		</div>
		<div class="middle">
			<div class="middle_left">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="企业资料提交" name="0">
						<div class="tab_item">
							<div class="item_title">资质申请阶段</div>
							<div class="item_content">
								<div class="content_item" @click="toUnitDetails">
									<div class="item_img">
										<img src="@/assets/images/icon 8@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>资质申请登记</div>
										<div>
											<span>新办申请</span>
											<span>延续申请</span>
											<span>补充材料</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 1@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>现场审查整改报告</div>
										<div>
											<span>点击登记</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="tab_item">
							<div class="item_title">资质申请阶段</div>
							<div class="item_content">
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 10@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>年度自检报告</div>
										<div>
											<span>点击登记</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 3@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>涉密人员备案</div>
										<div>
											<span>人员备案</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>项目备案</div>
										<div>
											<span>新办申请</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 5@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>事项变更申请</div>
										<div>
											<span>新办申请</span>
											<span>延续申请</span>
											<span>补充材料</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 9@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>证书变更申请</div>
										<div>
											<span>新办申请</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 7@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>保密检查整改</div>
										<div>
											<span>新办申请</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 2@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>新增/变更涉密场所申请</div>
										<div>
											<span>新办申请</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 6@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>注销申请</div>
										<div>
											<span>新办申请</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 4@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>交原证件</div>
										<div>
											<span>新办申请</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="行政事项通知" name="1">
						<div class="tab_item">
							<div class="item_title">资质申请阶段</div>
							<div class="item_content">
								<div class="content_item" @click="toUnitDetails">
									<div class="item_img">
										<img src="@/assets/images/icon 4@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>资质申请登记</div>
										<div>
											<span>新办申请</span>
											<span>延续申请</span>
											<span>补充材料</span>
										</div>
									</div>
								</div>
								<div class="content_item">
									<div class="item_img">
										<img src="@/assets/images/icon 6@3x.png" alt="">
									</div>
									<div class="item_text">
										<div>现场审查整改报告</div>
										<div>
											<span>点击登记</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-tab-pane>

				</el-tabs>
			</div>
			<div class="middle_right">
				<div class="title">
					待办事项
					<i class="el-icon-more"></i>
				</div>
				<div class="right_item">
					<div class="item_head">
						<div class="state_one">材料齐全</div>
						<i class="el-icon-view"></i>
					</div>
					<div class="item_steps">
						<el-steps direction="vertical">
							<el-step icon="el-icon-bangzhu">
								<template slot="title">
									<div class="step_title">
										<span>张三</span>
										<span>2022-07-19 00:36:11</span>
										<span>登记了</span>
									</div>
								</template>
								<template slot="description">
									<div class="step_description">
										<div class="description_name">
											成都瑞安信信息有限公司 的申请信息
										</div>
										<div class="description_classify">
											集成资质 | 乙级 | 总体集成
										</div>
									</div>
								</template>
							</el-step>
							<el-step>
								<template slot="title">
									<div class="select_title">
										<span>
											<i class="el-icon-printer"></i>
											材料接受通知书
										</span>
										<span>
											<i class="el-icon-printer"></i>
											受理审查表
										</span>
										<span>
											<i class="el-icon-printer"></i>
											书面审批表
										</span>
										<span>
											<i class="el-icon-printer"></i>
											受理结果通知书
										</span>
									</div>
								</template>
							</el-step>
						</el-steps>
					</div>
					<div class="progress_bar">
						<div class="item-content-percentage">
							<div class="color-bg" :style="{width:(25 / 100).toFixed(2) * 100 + '%'}">
							</div>
						</div>
						<div class="bar_name">
							<div><img src="@/assets/images/8–149@3x.png">申请</div>
							<div><img src="@/assets/images/8–149@3x.png">材料接收</div>
							<div><img src="@/assets/images/10379@3x.png">受理</div>
							<div><img src="@/assets/images/10379@3x.png">书面审查</div>
							<div><img src="@/assets/images/10379@3x.png">现场审查</div>
							<div><img src="@/assets/images/10379@3x.png">发证</div>
						</div>
					</div>
				</div>
				<div class="divider"></div>
				<div class="right_item">
					<div class="item_head">
						<div class="state_six">材料不齐全 <i class="el-icon-time" style="color: #fff;font-size: 12px;"></i>
							1天 21小时 23分</div>
						<i class="el-icon-view"></i>
					</div>
					<div class="item_steps">
						<el-steps direction="vertical">
							<el-step icon="el-icon-bangzhu">
								<template slot="title">
									<div class="step_title">
										<span>张三</span>
										<span>2022-07-19 00:36:11</span>
										<span>登记了</span>
									</div>
								</template>
								<template slot="description">
									<div class="step_description">
										<div class="description_name">
											成都瑞安信信息有限公司 的申请信息
										</div>
										<div class="description_classify">
											集成资质 | 乙级 | 总体集成
										</div>
									</div>
								</template>
							</el-step>
							<el-step>
								<template slot="title">
									<div class="select_title">
										<span>
											<i class="el-icon-printer"></i>
											补齐材料
										</span>
									</div>
								</template>
							</el-step>
						</el-steps>
					</div>
					<div class="progress_bar">
						<div class="item-content-percentage">
							<div class="color-bg" :style="{width:(25 / 100).toFixed(2) * 100 + '%'}">
							</div>
						</div>
						<div class="bar_name">
							<div><img src="@/assets/images/8–149@3x.png">申请</div>
							<div><img src="@/assets/images/8–149@3x.png">材料接收</div>
							<div><img src="@/assets/images/10379@3x.png">受理</div>
							<div><img src="@/assets/images/10379@3x.png">书面审查</div>
							<div><img src="@/assets/images/10379@3x.png">现场审查</div>
							<div><img src="@/assets/images/10379@3x.png">发证</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tail">
			<div class="tail_left">
				<div class="title">
					申请类别统计
					<i class="el-icon-more" style="transform:rotate(90deg);"></i>
				</div>
				<div class="left_echart">
					<div id="peiEcharts" class="full"></div>
				</div>
			</div>
			<div class="tail_right">
				<div class="title">
					近30天资质申请统计
					<!-- <i class="el-icon-more" style="transform:rotate(90deg);"></i> -->
				</div>
				<div class="right_echart">
					<div id="echarts" class="full"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	export default {
		data() {
			return {
				activeName: '0'
			};
		},
		mounted() {
			this.$nextTick(() => {
				this.getPeiEcharts()
				this.getEcharts()
			})
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			},
			toUnitDetails() {

				this.$router.push('/Worktable/unitDetails')
			},
			getPeiEcharts() {
				let chartDom = document.getElementById('peiEcharts')
				let myChart = echarts.init(chartDom)
				let data = [{
						name: '新办申请',
						value: 5
					},
					{
						name: '延续申请',
						value: 6
					},
				]
				let totalNum = 0
				data.map(item => totalNum += item.value)
				let option = {
					// title: {
					// 	text: `{a|全部}\n\n{b|${totalNum}}`,
					// 	top: 'center',
					// 	// left: 90,
					// 	textStyle: {
					// 		rich: {
					// 			a: {
					// 				fontSize: 16,
					// 				padding: [0, 0, 0, 200],
					// 				color: '#a6a1c0'
					// 			},
					// 			b: {
					// 				fontSize: 28,
					// 				padding: [0, 0, 0, 200],
					// 				color: '#24262b'
					// 			}
					// 		}
					// 	}
					// },
					color: [
						'#0045E6',
						'#F7931A',
					],
					legend: {
						orient: 'vertical',
						icon: 'circle',
						bottom: 15,
						textStyle: {
							rich: {
								b: {
									padding: [0, 2, 0, 40],
									fontSize: 14,
									color: '#24262b'
								},
								c: {
									fontSize: 14,
									color: '#24262b'
								},
							}
						},
						formatter(name) { // 该函数用于设置图例显示后的百分比
							let total = 0
							let value = 0
							data.forEach((item) => {
								total += item.value
								if (item.name == name) {
									value = item.value
								}
							})
							let p = ((value / total) * 100).toFixed(1) // 求出百分比
							return ['{c|' + `${name}${'('+p+'%'+')'}` + '}{b|' + `${value}` + '}']
						},
					},
					tooltip: {
						trigger: 'item',
					},

					series: [{
						type: 'pie',
						radius: ['30%', '60%'],
						center: ['50%', '50%'],
						roseType: 'radius',
						minShowLabelAngle: 60,
						label: {
							show: true,
							position: 'center',
							color: '#24262b',
							formatter: '{a|全部}' + '\n\r' + '{b|' + totalNum + '}',
							rich: {
								a: {
									fontSize: 14,
									fontFamily: "微软雅黑",
									color: '#24262b'
								},
								b: {
									fontFamily: "微软雅黑",
									fontSize: 28,
									color: '#24262b',
									lineHeight: 40,
								},
							}
						},
						labelLine: {
							length: 1,
							length2: 10,
							smooth: true
						},
						data: data,
					}]
				};
				option && myChart.setOption(option)
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			},
			getEcharts() {
				let chartDom = document.getElementById('echarts')
				let myChart = echarts.init(chartDom)
				let option = {
					color: ['#f7931a', '#4441de', '#00ada3'],
					title: {
						text: '全部',
						textStyle: {
							color: '#a6a1c0',
							fontWeight: 'lighter',
							fontFamily: 'Microsoft YaHei',
							fontSize: 16, //字体大小
						},
						subtext: '965,464',
						subtextStyle: {
							color: '#24262b', //字体颜色
							fontSize: 28, //字体大小
						}
					},
					tooltip: {
						trigger: 'axis',
					},
					grid: {
						left: '25',
						right: '25',
						top: '75',
						bottom: '10',
						containLabel: true,
					},

					legend: {
						orient: 'horizontal',
						icon: 'circle',
						show: true,
						right: 20,
						top: 25,
						itemWidth: 14,
						itemHeight: 14,
					},
					xAxis: {
						type: 'category',
						data: ['1.21', '1.22', '1.23', '1.24', '1.25', '1.26', '1.27'],
						boundaryGap: false,
						axisTick: {
							lineStyle: {
								color: '# d9d9d9 ',
							},
						},
						axisLine: {
							lineStyle: {
								color: '#d9d9d9',
							},
						},
						axisLabel: {
							color: '#aeaeae'
						}
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							color: '#999',
							textStyle: {
								fontSize: 12,
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#F3F4F4',
								width: 2,
								type: 'dashed',
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false,
						},
					},
					series: [{
							name: '印制资质',
							type: 'line',
							smooth: true,
							showSymbol: false,
							lineStyle: {
								width: 4
							},
							data: [13, 1, 4, 44, 45, 322, 76],
						},
						{
							name: '集成资质',
							type: 'line',
							smooth: true,
							showSymbol: false,
							lineStyle: {
								width: 4
							},
							data: [13, 54, 34, 344, 35, 53, 35],
						},
						{
							name: '军工资质',
							type: 'line',
							smooth: true,
							showSymbol: false,
							lineStyle: {
								width: 4
							},
							data: [14, 24, 44, 255, 135, 33, 65],
						},
					],
				};
				option && myChart.setOption(option)
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			}
		},
	};
</script>

<style scoped lang="less">
	.wrap {
		width: 100%;
		height: 100%;
		padding: 24px !important;
		box-sizing: border-box;

		.title {
			height: 26px;
			font-family: Microsoft YaHei;
			font-size: 20px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 24px;
			letter-spacing: 0px;
			color: #24262b;
			display: flex;
			justify-content: space-between;
		}

		.head {
			display: flex;
			justify-content: space-evenly;
			height: 160px;
			background-color: #ffffff;
			box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
			border-radius: 16px;

			.head_item {
				width: 260px;
				height: 160px;
				padding: 50px 24px;
				display: flex;
				box-sizing: border-box;

				.item_img {
					width: 60px;
					height: 60px;

					img {
						width: 100%;
					}
				}

				.item_text {
					margin-left: 16px;
					font-size: 14px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 17px;
					letter-spacing: 0px;
					color: #545454;

					div:nth-child(1) {
						font-size: 28px;
						line-height: 36px;
						color: #24262b;
					}
				}
			}
		}



		.middle {
			display: flex;
			margin: 16px 0;

			.middle_left {
				width: 60%;
				// height: 592px;
				background-color: #ffffff;
				box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
				border-radius: 16px;
				margin-right: 16px;
				padding: 24px;
				box-sizing: border-box;

				.tab_item {
					.item_title {
						height: 19px;
						font-size: 14px;
						font-weight: normal;
						font-stretch: normal;
						line-height: 19px;
						letter-spacing: 0px;
						color: #545454;
						margin-top: 16px;
					}

					.item_content {
						display: flex;
						flex-wrap: wrap;

						.content_item {
							width: 294px;
							height: 86px;
							background-color: #f5f6fa;
							border-radius: 8px;
							margin-top: 16px;
							display: flex;
							padding: 21px 24px;
							box-sizing: border-box;

							.item_img {
								width: 44px;
								height: 44px;

								img {
									width: 100%;
									height: 100%;
								}
							}

							.item_text {
								flex: 1;
								font-family: Microsoft YaHei;
								font-size: 12px;
								font-weight: normal;
								font-stretch: normal;
								line-height: 17px;
								letter-spacing: 0px;
								color: #545454;
								margin: 0 16px;

								div:nth-child(1) {
									font-size: 16px;
									line-height: 29px;
									color: #24262b;
								}

								div:nth-child(2) {
									display: flex;
									justify-content: space-between;
								}

							}
						}

						.content_item:nth-child(2) {
							margin-right: 16px;
							margin-left: 16px;
						}

						.content_item:nth-child(5) {
							margin-right: 16px;
							margin-left: 16px;
						}

						.content_item:nth-child(8) {
							margin-right: 16px;
							margin-left: 16px;
						}
					}
				}
			}

			.middle_right {
				width: 40%;
				// height: 592px;
				padding: 24px;
				box-sizing: border-box;
				background-color: #ffffff;
				box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
				border-radius: 16px;

				.divider {
					height: 0px;
					border: solid 1px #eeeeee;
				}



				.right_item {
					margin-top: 24px;
					height: 243px;

					.item_head {
						display: flex;
						justify-content: space-between;

						i {
							font-size: 21px;
							color: #545454;
						}
					}

					.item_steps {
						margin: 24px 0;
						height: 115px;

						.step_title {
							font-size: 12px;
							color: #545454;

							span:nth-child(2) {
								margin: 0 12px;
							}
						}

						.step_description {
							font-family: Microsoft YaHei;
							font-weight: normal;
							font-stretch: normal;
							letter-spacing: 0px;

							.description_name {
								font-size: 16px;
								line-height: 34px;
								color: #24262b;
							}

							.description_classify {
								font-size: 12px;
								line-height: 14px;
								color: #545454;
							}
						}

						.select_title {
							font-size: 12px;
							font-weight: normal;
							font-stretch: normal;
							letter-spacing: 0px;
							color: #0147eb;

							span {
								margin-right: 18px;
							}
						}
					}

					.progress_bar {
						height: 34px;

						.item-content-percentage {
							position: relative;
							height: 4px;
							background: #F6F6F6;

							.color-bg {
								position: absolute;
								top: 0;
								line-height: 0;
								height: 4px;
								background: repeating-linear-gradient(120deg, #71B945, #71B945 5px, #8DC76A 5px, #8DC76A 12px);
								width: 80%;
							}
						}

						.bar_name {
							height: 30px;
							display: flex;
							justify-content: space-between;
							font-family: Microsoft YaHei;
							font-size: 12px;
							font-weight: normal;
							font-stretch: normal;
							line-height: 30px;
							letter-spacing: 0px;
							color: #545454;

							div {
								display: flex;
								align-items: center;
							}

							img {
								width: 12px;
								height: 12px;
								margin-right: 5px;
							}
						}
					}




				}
			}
		}

		.tail {
			display: flex;

			.tail_left {
				width: 30%;
				height: 503px;
				padding: 24px;
				box-sizing: border-box;
				background-color: #ffffff;
				box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
				border-radius: 16px;
				margin-right: 16px;

				.left_echart {
					width: 100%;
					height: calc(100% - 26px);
				}
			}

			.tail_right {
				width: 70%;
				padding: 24px;
				box-sizing: border-box;
				height: 503px;
				background-color: #ffffff;
				box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
				border-radius: 16px;

				.right_echart {
					width: 100%;
					height: calc(100% - 26px);
				}
			}
		}
	}
</style>
